import script from "./commenBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./commenBtn.vue?vue&type=script&setup=true&lang=js"

import "./commenBtn.vue?vue&type=style&index=0&id=3c40c1fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c40c1fa"]])

export default __exports__